export function validateTime(value: string) {
    const timeFormat = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
    return timeFormat.test(value);
}

export function dateToAz(date: string) {
    return new Date(date).toLocaleString('en-US', {
        timeZone: 'America/Phoenix',
    });
}
